import type { ActiveOrganizationProps } from '@providers/userContextProvider';

export const isViewedOrganizationFeesDisabled = (
  feeEnableToggleEnabled: boolean,
  activeOrganization: Pick<ActiveOrganizationProps, 'feeSetting'>,
) =>
  feeEnableToggleEnabled &&
  Boolean(activeOrganization.feeSetting) &&
  !activeOrganization.feeSetting?.enabled;
